import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFarm } from '../context/FarmContext';
import { getFarmOverviewPath } from '../utils/farmRoutes';

/**
 * For superuser farm picker: sync localStorage/context with URL + API (overview route).
 * Uses JWT farmId when the user selects "default" (cleared override).
 */
export function useSuperuserFarmPickerNavigate() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { setFarmContextId } = useFarm();

  return useCallback(
    (rawId) => {
      const id = rawId && String(rawId).trim() ? String(rawId).trim() : null;
      if (id) {
        setFarmContextId(id);
      } else {
        setFarmContextId(null);
      }
      const targetFarmId = id || user?.farmId;
      const path = getFarmOverviewPath(targetFarmId);
      if (path) {
        navigate(path, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    },
    [navigate, setFarmContextId, user?.farmId]
  );
}
